<template>
  <div v-if="showTutorial" class="tutorial-overlay" @click="closeTutorial">
    <div class="tutorial-content" @click.stop>
      <!-- 閉じるボタン -->
      <img
        src="@/assets/modal-close.png"
        alt="閉じる"
        class="tutorial-close-button"
        @click="closeTutorial"
      />

      <!-- チュートリアルの画像 -->
      <div class="tutorial-image-container" :class="`image-${currentStep}`">
        <div class="tutorial-image-wrapper">
          <img
            :src="currentTutorialImage"
            class="tutorial-image"
          />
          <!-- 重畳するボタン -->
          <img
            v-if="currentStep === 1"
            :src="require('../assets/tutorial/next.png')"
            alt="次へ"
            class="tutorial-overlay-button tutorial-next-button-1"
            @click="nextStep"
          />
          <img
            v-if="currentStep === 2"
            :src="require('../assets/tutorial/next.png')"
            alt="次へ"
            class="tutorial-overlay-button tutorial-next-button-2"
            @click="nextStep"
          />
          <img
            v-if="currentStep === 3"
            :src="require('../assets/tutorial/next.png')"
            alt="次へ"
            class="tutorial-overlay-button tutorial-next-button-3"
            @click="nextStep"
          />
          <img
            v-if="currentStep === 4"
            :src="require('../assets/tutorial/finish.png')"
            alt="完了"
            class="tutorial-overlay-button tutorial-finish-button"
            @click="closeTutorial"
          />
          <!-- 4つ目の吹き出し内の左端ボタン -->
          <div v-if="currentStep === 4" class="tutorial-left-buttons">
            <img
              :src="require('../assets/tutorial/4_share.png')"
              alt="共有"
              class="tutorial-left-button tutorial-share-button"
            />
            <img
              :src="require('../assets/tutorial/4_save.png')"
              alt="保存"
              class="tutorial-left-button tutorial-save-button"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tutorial',
  data () {
    return {
      showTutorial: false,
      currentStep: 1
    }
  },
  computed: {
    currentTutorialImage () {
      const step = this.currentStep
      return require(`../assets/tutorial/tutorial_${step}.png`)
    }
  },
  methods: {
    openTutorial () {
      this.showTutorial = true
      this.currentStep = 1
    },
    closeTutorial () {
      this.showTutorial = false
      this.currentStep = 1
    },
    nextStep () {
      if (this.currentStep < 4) {
        this.currentStep++
      } else {
        this.closeTutorial()
      }
    },
    resetTutorial () {
      this.currentStep = 1
    }
  }
}
</script>

<style scoped>
.tutorial-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 16777273;
}

.tutorial-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tutorial-close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  z-index: 10;
}

.tutorial-image-container {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: fadeIn 0.3s ease;
  position: fixed;
}

.image-1 {
  /* position: fixed; */
  top: 360px;
  left: 20px;
  /* transform: translate(-50%, -50%); */
}

.image-2 {
  bottom: 140px;
  left: -100px;
  width: 700px;
}

.image-3 {
  bottom: 130px;
  left: 90px;
  /* transform: translateX(-50%); */
  width: 700px;
}

.image-4 {
  bottom: 140px;
  left: -130px;
  /* transform: translateX(-50%); */
  width: 700px;
}

.tutorial-image-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tutorial-image {
  max-width: 500px;
  width: 60%;
  height: auto;
  border-radius: 15px;
  /* box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3); */
}

.tutorial-overlay-button {
  position: absolute;
  cursor: pointer;
  transition: transform 0.3s ease;
  z-index: 5;
  width: 80px;
  height: auto;
}

.tutorial-next-button-1 {
  bottom: 10%;
  width: 80px;
  /* right: 20%; */
}

.tutorial-next-button-2 {
  /* bottom: 20%;
  right: 15%; */
  width: 80px;
}

.tutorial-next-button-3 {
  /* bottom: 20%;
  right: 15%; */
  width: 80px;
}

.tutorial-finish-button {
  bottom: 60px;
  /* right: 15%; */
  width: 160px;
}

.tutorial-left-buttons {
  position: absolute;
  left: 155px;
  /* top: 50%; */
  bottom: 105px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 15px;
  z-index: 5;
}

.tutorial-left-button {
  width: 30px;
  height: auto;
  transition: transform 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
